import { useEffect, useMemo, useState } from "react";
import Lenis from "lenis";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangContext, translations, CONTACT } from "./i18n";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import { AuthCallback } from "./pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("tsm-lang") || "it");

  useEffect(() => {
    localStorage.setItem("tsm-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true, anchors: { offset: -70 } });
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  const value = useMemo(() => ({ lang, setLang, t: translations[lang], wa: lang === "fr" ? CONTACT.whatsappTn : CONTACT.whatsapp }), [lang]);
  return (
    <LangContext.Provider value={value}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </LangContext.Provider>
  );
}

export default App;
